import axios from "axios";

export class MaintenanceDomainsService {
    /**
     * Función que hace petición al back para obtener datos para la
     * tabla en la pantalla de mantenimiento de usuarios
     * @returns {Promise<unknown>}
     */
    getDataDomains() {
        return axios.get('/appapv/getDataDomainEmail.action', {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(res => res.data.payload);
    }

    /**
     * Función que hace una petición al back para insertar un nuevo elemento.
     * @param objectAccount Elemento a insertar
     * @returns {Promise<any>}
     */
    insertDomain(domainObject) {
        return axios.post('/appapv/insertEmailDomain.action', {}, {
            params: {
                dominio: domainObject.domain ? domainObject.domain : '',
                idInstitucion: domainObject.idInstitucion ? domainObject.idInstitucion : 0,
            }
        }).then(res => this.getDataDomains());
    }

    /**
     * Función que hace una petición al back para insertar un nuevo elemento.
     * @param objectAccount Elemento a insertar
     * @returns {Promise<any>}
     */
    deleteDomain(domainObject) {
        return axios.delete('/appapv/deleteEmailDomain.action', {
            params: {
                dominio: domainObject.dominio ? domainObject.dominio : '',
                idInstitucion: domainObject.idInstitucion,
            }
        }).then(res => this.getDataDomains());
    }
}